


































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import notificationService from '@/services/notificationService';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import mailTemplatesRepository from '@/services/default/mailTemplatesRepository';

import {
  ContactsClient,
  ProjectContactsClient,
  ContactsLookupQuery,
  DataSourceLoadOptionsBase,
  IContactListItemDto,
  ProjectAddOrUpdateContactCommand,
  IProjectAddOrUpdateContactCommand,
  IProjectContactDto,
  ContactListItemDto,
} from '@/data/web-api-client';

import { DxForm, DxSimpleItem, DxRequiredRule, DxEmailRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxScrollView,
    DxRequiredRule,
    DxEmailRule,
  },
})
export default class ProjectContactLookupPopup extends Vue {
  show: boolean = false;
  saving: boolean = false;
  fullscreen: boolean = false;
  formdata: IProjectAddOrUpdateContactCommand = {
    id: '',
    projectId: '',
    tags: [],
    sendInvoice: false,
    sendQuotation: false,
    sendProgressStatement: false,
    sendProjectFiches: false,
  };

  @Prop({ required: true })
  projectId!: string;

  @Prop({ required: false })
  contact!: IProjectContactDto;

  public async open() {
    setTimeout(() => {
      this.show = true;
    }, 150);
  }

  async save() {
    try {
      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (!validationResult.isValid) {
        notificationService.invalidForm();
        return;
      }

      this.saving = true;
      this.formdata.projectId = this.projectId;
      const result = await new ProjectContactsClient(undefined, this.$axios).addOrUpdateContact(this.projectId, new ProjectAddOrUpdateContactCommand(this.formdata));

      this.formdata.id = undefined;
      this.$emit(this.editMode ? 'changed' : 'added', result);

      this.show = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  get editMode() {
    if (this.contact) {
      return true;
    }
    return false;
  }

  get contactDataSource() {
    const client = new ContactsClient(undefined, this.$axios);
    return new DataSource({
      store: new dxCustomStore({
        key: 'id',
        load: async (loadOptions) => {
          if (Array.isArray(loadOptions.filter) && loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {
            return {
              data: [],
              totalCount: 0,
            };
          }

          if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
            loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
          }

          const options = new DataSourceLoadOptionsBase(loadOptions);
          options.init(
            Object.assign({}, loadOptions, {
              stringToLower: true,
            })
          );
          const res = await client.lookupContacts(
            new ContactsLookupQuery({
              options,
            })
          );

          return res;
        },
        byKey: async (val: string) => {
          if (!val || val === '') {
            return null;
          }

          return await client.getBasicInfo(val);
        },
      }),
      paginate: true,
    });
  }

  get contactOptions() {
    const self = this;
    return {
      dataSource: this.contactDataSource,
      disabled: this.contact ? true : false,
      searchEnabled: true,
      remoteOperations: true,
      showClearButton: true,
      searchExpr: 'displayName',
      valueExpr: 'id',
      displayExpr: (contact: ContactListItemDto) => {
        if (!contact) return;
        return `${contact?.type == 'Subcontractor' ? 'OA - ' : ''} ${contact?.displayName ?? ''}`;
      },
      itemTemplate: (contact: ContactListItemDto) => {
        let icon = 'fa-user';
        switch (contact?.type) {
          case 'Subcontractor':
            icon = 'fa-hard-hat';
            break;
          case 'Company':
            icon = 'fa-building';
            break;
        }
        return `<i class="fas ${icon}"></i> ${contact?.displayName}`;
      },
    };
  }

  get projectContactTagsOptions() {
    const catalog = this.$store.getters['catalogs/list']('ProjectContactTags');
    const self = this;

    return {
      dataSource: catalog ? catalog.values : [],
    };
  }

  @Watch('contact', { deep: true })
  onContactChanged() {
    if (this.contact) {
      Object.assign(this.formdata, {
        id: this.contact.contact!.id,
        tags: this.contact.tags,
        sendInvoice: this.contact.sendInvoice,
        sendQuotation: this.contact.sendQuotation,
        sendProgressStatement: this.contact.sendProgressStatement,
        sendProjectFiches: this.contact.sendProjectFiches,
      });
    } else {
      Object.assign(this.formdata, {
        id: '',
        tags: [],
        sendInvoice: false,
        sendQuotation: false,
        sendProgressStatement: false,
        sendProjectFiches: false,
      });
    }

    this.formdata.projectId = this.projectId;
  }
}
